import { createElementBlock as o, openBlock as l, createElementVNode as n } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 21"
};
function t(v, e) {
  return l(), o("svg", r, [...e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M14.082 3.51c-1.217-.075-2.153.596-2.724 1.464-.564.858-.825 1.971-.723 3.011.164 1.669 1.141 2.935 2.65 3.479v5.081h.75-.75a.75.75 0 0 0 1.5 0h-.75.75V11.4a4.1 4.1 0 0 0 1.472-1.168c.49-.63.765-1.394.846-2.25.092-.97-.087-2.015-.563-2.857-.485-.859-1.308-1.543-2.458-1.614m.99 5.802c-.253.326-.608.6-1.086.803-1.082-.312-1.744-1.118-1.858-2.276-.07-.716.117-1.484.483-2.04.36-.547.835-.825 1.377-.791.535.033.952.334 1.246.854.303.537.443 1.266.376 1.98-.059.616-.249 1.098-.537 1.47M4.505 4.259a.75.75 0 1 0-1.5 0v6.31c0 .413.336.75.75.75h1.738v5.558a.75.75 0 0 0 1.5 0v-5.559h1.737a.75.75 0 0 0 .75-.75v-6.31a.75.75 0 0 0-1.5 0v5.56h-.987v-5.56a.75.75 0 1 0-1.5 0v5.56h-.988z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const a = { render: t };
export {
  a as default,
  t as render
};
